(function ($) {
    class RLM_Tracking {
        constructor () { 
            this.initEvents();
        }

        initEvents () {
            if ($('#join-us-cta').length) {
                $('#join-us-cta').on('click', function () {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'rekrutacja',
                        'eventAction': 'klik kogo szukamy',
                        'eventCategory': 'rekrutacja',
                        'eventLabel': ''
                    });
                });
            } 
            
            if ($('.career-item').length) {
                let btns = $('.career-item .btn');

                for (let i = 0; i < btns.length; i++) {
                    btns.eq(i).on('click', function () {
                        let position = '';

                        if ($(this).prop('tagName') === 'A') {
                            position = $(this).attr('data-position');
                        } else {
                            position = $(this).parent().attr('data-position');
                        }

                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            'event': 'rekrutacja',
                            'eventAction': 'klik oferta',
                            'eventCategory': 'rekrutacja',
                            'eventLabel': position
                        });
                    });
                }
            }    
        }
    }
    
    new RLM_Tracking();
})(jQuery);